export default [
  { value: 'PAID', label: 'Paid' },
  { value: 'PENDING', label: 'Pending' },
];
